import { Card, SectionCard, SectionCardMobile } from './styles'

import React from 'react'
import { MeetLabels } from 'src/types'
import { useAnimation } from 'src/hook'
import { TeamContent } from './TeamContent'

export const MapTeam = ({
    image,
    WorkField,
    name,
    textCity,
    id,
    animation,
}: MeetLabels) => {
    const { control, ref } = useAnimation({ initialSpriteIdTitle: 2 })
    return (
        <Card ref={ref}>
            <SectionCard
                initial="hidden"
                animate={control}
                variants={animation}
            >
                <TeamContent
                    id={id}
                    image={image}
                    name={name}
                    textCity={textCity}
                    WorkField={WorkField}
                />
            </SectionCard>
            <SectionCardMobile>
                <TeamContent
                    id={id}
                    image={image}
                    name={name}
                    textCity={textCity}
                    WorkField={WorkField}
                />
            </SectionCardMobile>
        </Card>
    )
}
